module.exports = __webpack_public_path__ + "static/media/xls-simple-icon.a57a49a1.svg";